<template>
    <div >
        <h1 style="padding: 10px 0">荣誉资质</h1>
        <hr>
        <el-form ref="form" :model="form" label-width="0">
            <el-form-item>
                <el-row>
                    <el-col style="overflow: hidden;padding: 20px;text-align: center;border: 1px solid #ccc" :span="6" v-for="(item,index) in imgsrc" v-if="imgsrc.length !=0" :key="index" >
                        <img style="width: 200px;height: 100px;border: 1px solid black" :src="item" alt="">
                        <el-upload
                                class="upload-demo"
                                :action="imgUrl"
                                :on-change="handleChange"
                                :on-success="handleAvatarSuccess"
                                :on-remove="handleChange"
                                :file-list="fileList">
                            <el-button size="small" type="primary" @click="upload(index)">点击更换图片</el-button>
                            <el-button size="small" type="danger" icon="el-icon-delete" circle  @click="deleteThis(index)"></el-button>

                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload>
                    </el-col>
                </el-row>

            </el-form-item>

            <el-form-item>
                <el-upload
                        class="upload-demo"
                        :action="imgUrl"
                        :on-change="handleChange"
                        :on-success="handleAvatarAddSuccess"
                        :on-remove="handleChange"
                        :file-list="fileList">
                    <el-button size="small" type="primary" >点击添加</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                </el-upload>

            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">提交</el-button>
                <el-button @click="this.$router.back()">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import {getCurrentInstance} from "vue";
    export default {
        name: "gongsijianjie",

        data(){
            return{
                fileList: [],
                form:{},
                imgsrc:[],
                imgUrl:""
            }
        },
        methods:{
            handleAvatarSuccess(res) {


                this.fileList.url=res
                this.imgsrc[this.imgIndex]=res
            },
            handleAvatarAddSuccess(res) {


                this.fileList.url=res
                this.imgsrc.push(res)
            },
            upload(index){
                this.imgIndex=index
            },
            deleteThis(index){
                this.imgsrc.splice(index,1)
            },
            onSubmit(){
                this.form.navName=""
                for (let i = 0; i <this.imgsrc.length ; i++) {
                    if (i==this.imgsrc.length-1){
                        this.form.navName+=this.imgsrc[i]
                    }else {
                        this.form.navName+=this.imgsrc[i]+","
                    }
                }


                this.$refs['form'].validate((valid) => {
                    if (valid){
                        // console.log(JSON.stringify(this.form));
                        request.post("/about_magangent/updateHonor",this.form).then(res => {

                            if (res.code==200){
                                this.$message({
                                    type: 'success',
                                    message: res.data
                                });
                            }else {
                                this.$message({
                                    type: 'warning',
                                    message: res.data
                                });
                            }


                        })
                    }else{
                    }

                })

            },
        },

        mounted() {
            const internalInstance  = getCurrentInstance(); //  方式二，此方法在开发环境以及生产环境下都能放到组件上下文对象（推荐）
            const globalProperties = internalInstance.appContext.config.globalProperties
            const imgUrl= globalProperties.$imgUrl

            this.imgUrl=imgUrl
            request.get("/about_magangent/gethonor").then(res => {
                this.form=res.data
                if (res.code==200&&res.data.navName!=""){

                    this.imgsrc =res.data.navName.split(",")
                    // console.log(JSON.stringify(res));
                    //
                    // console.log(this.imgsrc.length);
                }else {

                }


            })
        }
    }
</script>

<style scoped>

</style>